import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function TourDates() {
  const shows = [{
    id: 1,
    date: 'MAR 07',
    venue: 'La Vaquera',
    location: 'San Pedro Garza García',
    status: 'Tickets Available'
  }, {
    id: 1,
    date: 'MAR 20',
    venue: 'Invino Cava y Copeo',
    location: 'Centrito Valle, San Pedro Garza García',
    status: 'Tickets Available'
  }];
  return <Section id="tour" className="bg-tx-primary" data-id="element-163">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-164">
        <div data-id="element-165">
          <h2 className="text-5xl md:text-7xl text-tx-cream" data-id="element-166">
            Live <span className="text-tx-red" data-id="element-167">Shows</span>
          </h2>
          <p className="text-tx-cream/60 font-body text-lg mt-4 max-w-2xl" data-id="element-168">
            Catch us on the road. Grab your tickets before they're gone.
          </p>
        </div>
      </div>

      <div className="border-t-2 border-tx-border" data-id="element-169">
        {shows.map(show => <div key={show.id} className="group flex flex-col md:flex-row md:items-center justify-between py-8 border-b border-tx-border hover:bg-tx-secondary/50 transition-colors px-4 -mx-4 md:px-6 md:-mx-6" data-id="element-170">
            <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-12 lg:gap-24 mb-6 md:mb-0" data-id="element-171">
              <div className="font-heading text-4xl md:text-5xl text-tx-red tracking-wider w-32" data-id="element-172">
                {show.date}
              </div>
              <div data-id="element-173">
                <h3 className="font-heading text-3xl text-tx-cream tracking-wider group-hover:text-tx-gold transition-colors" data-id="element-174">
                  {show.venue}
                </h3>
                <p className="text-tx-cream/60 font-body text-lg mt-1" data-id="element-175">
                  {show.location}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-6" data-id="element-176">
              {show.status === 'Sold Out' ? <span className="font-heading text-2xl text-tx-border tracking-widest uppercase" data-id="element-177">
                  Sold Out
                </span> : <Button variant="outline" className="w-full md:w-auto group-hover:border-tx-red group-hover:text-tx-red group-hover:bg-transparent" data-id="element-178">
                  Get Tickets
                </Button>}
            </div>
          </div>)}
      </div>

      <div className="mt-12 text-center" data-id="element-179">
        <p className="text-tx-cream/50 font-body italic" data-id="element-180">
          More dates to be announced soon.
        </p>
      </div>
    </Section>;
}